import { formatTime as formatSwissTime } from '@agentselly/ui';

/**
 * Uhrzeit als hh:mm. Dünne Hülle um den geteilten Formatter aus
 * `@agentselly/ui` (AGE-162).
 *
 * Zwei Eigenheiten gegenüber dem geteilten Formatter bleiben erhalten:
 * fehlende oder ungültige Daten ergeben den Leerstring statt `—`, und genau
 * Mitternacht gilt als "keine Uhrzeit gesetzt" und wird nicht angezeigt.
 * Die Mitternachtsprüfung läuft über das formatierte Ergebnis, damit sie
 * dieselbe Zeitzone sieht wie die Anzeige.
 */
export function formatTime(dateString: any): string {
  const time = formatSwissTime(dateString, { fallback: '' });

  return time === '00:00' ? '' : time;
}
